import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth, AppRole } from '@/contexts/AuthContext';

const ROUTE_ROLE_MAP: { prefix: string; role: AppRole }[] = [
  { prefix: '/admin', role: 'super_admin' },
  { prefix: '/club/', role: 'club_staff' },
  { prefix: '/association/', role: 'association_staff' },
  { prefix: '/tournament-manager', role: 'tournament_organizer' },
  { prefix: '/coach', role: 'coach' },
  { prefix: '/player/', role: 'player' },
];

/**
 * Synchronise activeRole avec le préfixe de la route courante.
 * Ex: si l'URL est /player/tournaments mais activeRole = association_staff,
 * on bascule automatiquement vers player.
 */
export function useRouteRoleSync() {
  const { pathname } = useLocation();
  const { activeRole, setActiveRole, hasRole } = useAuth();

  useEffect(() => {
    const match = ROUTE_ROLE_MAP.find((r) => pathname.startsWith(r.prefix));
    if (!match) return;
    if (match.role === activeRole) return;
    if (!hasRole(match.role)) return;

    setActiveRole(match.role);
  }, [pathname, activeRole, setActiveRole, hasRole]);
}
